import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Palau: Country = {
    identifier: "Palau",
    name: "Palau",
    countryCode: "PW",
    group: CountryGroup.OCEANIA,
    isUNMember: true,
    flag: "🇵🇼",
    svgPath: "m 852.63475,442.2854 -0.17,0.06 -0.08,-0.215 0.027,-0.25 0.112,-0.192 0.123,-0.061 0.024,-0.022 0.12,-0.249 0.023,0.137 -0.075,0.456 -0.098,0.177 -0.006,0.159 z m -9.606,12.196 -0.063,0.012 -0.041,-0.009 0.005,-0.04 0.042,-0.041 0.058,-0.018 0.044,0.014 -0.005,0.038 -0.04,0.044 z",
}
